import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { albumDtoSchema, type AlbumDto } from '@tg-hookah/shared/dto';
import { api } from '@/lib/api';

const listSchema = z.array(albumDtoSchema);

export function useAlbums() {
  return useQuery({
    queryKey: ['albums'],
    queryFn: async (): Promise<AlbumDto[]> => {
      const res = await api.get('/albums');
      return listSchema.parse(res.data);
    },
  });
}

export function useAlbum(id: string | undefined) {
  return useQuery({
    queryKey: ['album', id],
    enabled: !!id,
    queryFn: async (): Promise<AlbumDto> => {
      const res = await api.get(`/albums/${id}`);
      return albumDtoSchema.parse(res.data);
    },
  });
}
